import '../../styles/CaseListMetrics.css';
import '../../styles/CaseManagement.css';

function ClosedOutcomeBreakdown({ totalClosed, approvalRatePct, avgTimeToCloseDays }) {
    if (!totalClosed) return null;

    const rows = [];
    if (approvalRatePct != null) {
        rows.push({ key: 'approval', label: 'Approval rate', value: `${approvalRatePct}%` });
    }
    if (avgTimeToCloseDays != null) {
        rows.push({
            key: 'time-to-close',
            label: 'Avg time to close',
            value: `${avgTimeToCloseDays} days`,
        });
    }

    return (
        <div className="case-list-metrics__card closed-outcome-breakdown">
            <div className="closed-outcome-breakdown__header">
                <span className="closed-outcome-breakdown__label">Cases closed</span>
                <span className="closed-outcome-breakdown__total">{totalClosed}</span>
            </div>
            {rows.length > 0 && (
                <ul className="closed-outcome-breakdown__list">
                    {rows.map((row) => (
                        <li
                            key={row.key}
                            className="closed-outcome-breakdown__item"
                        >
                            <span className="closed-outcome-breakdown__metric-label">{row.label}</span>
                            <span className="closed-outcome-breakdown__count">{row.value}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default ClosedOutcomeBreakdown;
